/**
 * 404 from inside a `useAsyncData` handler. `showError()` needs the Nuxt
 * instance, which is gone after the handler's first await, so capture it at
 * setup and call `showError` through `runWithContext` — otherwise the throw is
 * swallowed and the response goes out as 200.
 */
export const usePageNotFound = () => {
	const { t } = useI18n();
	const nuxtApp = useNuxtApp();
	const event = useRequestEvent();

	const showPageNotFound = () =>
		nuxtApp.runWithContext(() => {
			// No event on client-side navigation — no status to set there.
			if (event) {
				setResponseStatus(event, 404);
			}

			showError({
				statusCode: 404,
				statusMessage: t("errors.page_not_found.title"),
				message: t("errors.page_not_found.message")
			});
		});

	return { showPageNotFound };
};
